<template>
	<div v-if="externalContent" class="w-full h-full">
		<iframe
			:title="externalContent.name"
			width="100%"
			height="100%"
			:src="contentSrc"
			frameborder="0"
			allowFullScreen="true"
		/>
	</div>
</template>

<script setup lang="ts">
import { ExternalContent, getExternalContent } from "@q-food/q-food";
import { useAppTabs } from "~stores/useAppTabs.ts";

const { setCurrentTabTitle } = useAppTabs();
const externalContent = ref({} as ExternalContent);
const props = defineProps<{
	resourceId: string;
}>();

getExternalContent(props.resourceId).then((response) => {
	externalContent.value = response;
	setCurrentTabTitle(response.name);
});

const contentSrc = computed(() => {
	if (externalContent.value?.content?.startsWith("<iframe")) {
		const temp = document.createElement("div");
		temp.innerHTML = externalContent.value.content;
		return temp.querySelector("iframe")?.getAttribute("src") || null;
	}

	return externalContent.value.content;
});
</script>

<style scoped></style>
